module.exports = __webpack_public_path__ + "img/567x600px-Terko.18c622aa.jpg";